(function (app, ng) {
    app.component("opportunitiesComponent",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Dashboard/Components/Opportunities/opportunities.template.html",
            controller: 'opportunitiesController',
            bindings: {
                startDate: "<",
                endDate: "<"
            }
        })
        .controller('opportunitiesController',
            ["marketingTrackerSalesTrackerDashboardApi", "chartColors", "$q",
                function (marketingTrackerSalesTrackerDashboardApi, chartColors, $q) {
                    var $ctrl = this;

                    ng.extend($ctrl, {
                        ui: {
                            loading: false
                        },
                        sourceColors: chartColors,
                        advisorColors: chartColors,
                        opportunitiesData: {}
                    });

                    $ctrl.$onInit = function () {
                        $ctrl.ui.loading = true;

                        const promises = [
                            marketingTrackerSalesTrackerDashboardApi.getOpportunitiesSummaryByDate($ctrl.startDate, $ctrl.endDate),
                            marketingTrackerSalesTrackerDashboardApi.getOpportunitiesSourcesByDate($ctrl.startDate, $ctrl.endDate),
                            marketingTrackerSalesTrackerDashboardApi.getOpportunitiesAppointmentsByDate($ctrl.startDate, $ctrl.endDate),
                            marketingTrackerSalesTrackerDashboardApi.getOpportunitiesAssetsByDate($ctrl.startDate, $ctrl.endDate),
                        ];
                        $q.all(promises)
                            .then(function (responses) {
                                $ctrl.opportunitiesData.Summary = responses[0];
                                $ctrl.opportunitiesData.Sources = responses[1];
                                $ctrl.opportunitiesData.Appointments = responses[2];
                                $ctrl.opportunitiesData.Assets = responses[3];
                            })
                            .catch(function (error) {
                                console.log(error.data)
                            })
                            .finally(function () {
                                $ctrl.ui.loading = false;
                            });
                    }
                }
            ]);
})(window.app, window.angular); //jshint ignore:line